import { Text, TextProps } from '@shopify/polaris';
import { memo } from 'react';

interface IProps extends Omit<TextProps, 'as'> {
  children: React.ReactNode;
}

const BoldLargeText = ({ children, ...textProps }: IProps) => {
  return (
    <Text as="span" variant="headingLg" {...textProps}>
      {children}
    </Text>
  );
};
export default memo(BoldLargeText);
